<aside *ngIf="isLoading" class="is-flex has-flex-align-center has-flex-content-center has-pos-fix">
  <div class="loader-wrapper">
    <img class="rm-loader" src="{{'/assets/gifs/loader.gif' | staticp}}"/>
  </div>
  <div class="background has-pos-abs"></div>
</aside>
